import type { IconProps } from "./types";

export function User({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.0996 21V19C19.0996 18.1778 18.7737 17.389 18.1924 16.8076C17.611 16.2263 16.8222 15.9004 16 15.9004H8C7.17783 15.9004 6.38898 16.2263 5.80762 16.8076C5.22625 17.389 4.90039 18.1778 4.90039 19V21C4.90039 21.4971 4.49706 21.9004 4 21.9004C3.50294 21.9004 3.09961 21.4971 3.09961 21V19C3.09961 17.7004 3.61623 16.4541 4.53516 15.5352C5.45408 14.6162 6.70044 14.0996 8 14.0996H16C17.2996 14.0996 18.5459 14.6162 19.4648 15.5352C20.3838 16.4541 20.9004 17.7004 20.9004 19V21C20.9004 21.4971 20.4971 21.9004 20 21.9004C19.5029 21.9004 19.0996 21.4971 19.0996 21Z"
        fill={currentColor}
      />
      <path
        d="M15.0996 7C15.0996 5.28792 13.7121 3.90039 12 3.90039C10.2879 3.90039 8.90039 5.28792 8.90039 7C8.90039 8.71208 10.2879 10.0996 12 10.0996C13.7121 10.0996 15.0996 8.71208 15.0996 7ZM16.9004 7C16.9004 9.7062 14.7062 11.9004 12 11.9004C9.2938 11.9004 7.09961 9.7062 7.09961 7C7.09961 4.2938 9.2938 2.09961 12 2.09961C14.7062 2.09961 16.9004 4.2938 16.9004 7Z"
        fill={currentColor}
      />
    </svg>
  );
}
